import download from "downloadjs";
import { customFetch } from "./CustomFetch";

export const ediIdsImportUrl = "candidate/edi";

const candidateCsvFileName = "kandidaten.csv";

export const exportAllCandidates = () => {
  return customFetch(`candidate/export`)
    .then((response) => response.blob())
    .then((blob) => {
      download(blob, candidateCsvFileName);
    });
};
